const VERSION_STORAGE_KEY = 'gem-vue-mall:build-version'
const VERSION_URL = '/version.json'

function readStoredVersion () {
  try {
    return window.localStorage.getItem(VERSION_STORAGE_KEY)
  } catch (error) {
    return null
  }
}

function storeVersion (version) {
  try {
    window.localStorage.setItem(VERSION_STORAGE_KEY, version)
  } catch (error) {
    // Disabled browser storage must not prevent the app from loading.
  }
}

/**
 * Checks the version emitted by the build before the Vue app starts. A changed
 * version means this tab loaded an older release, so it reloads once.
 */
export default function checkBuildVersion () {
  if (process.env.NODE_ENV === 'development') {
    return Promise.resolve()
  }

  return new Promise((resolve) => {
    const request = new XMLHttpRequest()
    request.open('GET', `${VERSION_URL}?_=${Date.now()}`, true)
    request.timeout = 5000
    request.setRequestHeader('Cache-Control', 'no-cache')

    request.onload = () => {
      if (request.status < 200 || request.status >= 300) {
        resolve()
        return
      }

      try {
        const version = JSON.parse(request.responseText).version
        if (!version) {
          resolve()
          return
        }

        const storedVersion = readStoredVersion()
        storeVersion(version)

        if (storedVersion && storedVersion !== version) {
          window.location.reload()
          return
        }
      } catch (error) {
        // A malformed version file should never block users from using the app.
      }

      resolve()
    }

    request.onerror = resolve
    request.ontimeout = resolve
    request.send()
  })
}



// WEBPACK FOOTER //
// ./src/utils/check-build-version.js